import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import '@/App.css';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import StickyMobileCTA from '@/components/layout/StickyMobileCTA';
import CookieBanner from '@/components/CookieBanner';
import HomePage from '@/pages/HomePage';
import PricingPage from '@/pages/PricingPage';
import ServicesPage from '@/pages/ServicesPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import FaqsPage from '@/pages/FaqsPage';
import LegalPage from '@/pages/LegalPage';
import NotFoundPage from '@/pages/NotFoundPage';
import TradeLandingTemplate from '@/pages/TradeLandingTemplate';
import PlumbersPage from '@/pages/PlumbersPage';
import ElectriciansPage from '@/pages/ElectriciansPage';
import BuildersPage from '@/pages/BuildersPage';
import DecoratorsPage from '@/pages/DecoratorsPage';
import RoofersPage from '@/pages/RoofersPage';
import LandscapersPage from '@/pages/LandscapersPage';
import CarpentersPage from '@/pages/CarpentersPage';
import PlasterersPage from '@/pages/PlasterersPage';
import HandymenPage from '@/pages/HandymenPage';
import ResourcesPage from '@/pages/ResourcesPage';
import { trackEvent } from '@/lib/analytics';

function useSmoothScroll() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}

function ScrollAndTrack() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent('page_view', { page_path: pathname });
  }, [pathname]);
  return null;
}

export default function App() {
  useSmoothScroll();
  return (
    <BrowserRouter>
      <ScrollAndTrack />
      <div className="flex min-h-screen flex-col bg-offwhite">
        <Header />
        <main id="main-content" className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faqs" element={<FaqsPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/cookies" element={<LegalPage />} />
            <Route path="/terms" element={<LegalPage />} />
            <Route path="/service-terms" element={<LegalPage />} />
            <Route path="/refunds" element={<LegalPage />} />
            <Route path="/accessibility" element={<LegalPage />} />
            <Route path="/websites-for-plumbers" element={<PlumbersPage />} />
            <Route path="/websites-for-electricians" element={<ElectriciansPage />} />
            <Route path="/websites-for-builders" element={<BuildersPage />} />
            <Route path="/websites-for-painters-decorators" element={<DecoratorsPage />} />
            <Route path="/websites-for-roofers" element={<RoofersPage />} />
            <Route path="/websites-for-landscapers" element={<LandscapersPage />} />
            <Route path="/websites-for-carpenters" element={<CarpentersPage />} />
            <Route path="/websites-for-plasterers" element={<PlasterersPage />} />
            <Route path="/websites-for-handymen" element={<HandymenPage />} />
            <Route path="/trade-template" element={<TradeLandingTemplate />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <div className="h-[68px] lg:hidden" aria-hidden="true" />
        <Footer />
        <StickyMobileCTA />
        <CookieBanner />
        <Toaster position="bottom-center" richColors />
      </div>
    </BrowserRouter>
  );
}
